import { cB as i, cM as t, c as a } from "./ghl-ui.es384.js";
const e = i("form", [t("inline", `
 width: 100%;
 display: inline-flex;
 align-items: flex-start;
 align-content: space-around;
 `, [i("form-item", {
  width: "auto",
  marginRight: "18px"
}, [a("&:last-child", {
  marginRight: 0
})])])]);
export {
  e as default
};
